// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnrollmentForm_container__yNMMg {
  margin: 48px 0px;
  width: 97.2%;
}
.EnrollmentForm_headerRow__uAHFE {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}
.EnrollmentForm_headerBox__-PG-5,
.EnrollmentForm_form__WbUcW,
.EnrollmentForm_formInputsContainer__-QF0S {
  display: flex;
  flex-direction: column;
}
.EnrollmentForm_backButton__YaKIM {
  align-items: center;
  column-gap: 16px;
  cursor: pointer;
  display: flex;
  height: 32px;
  width: fit-content;
  margin-bottom: 24px;
}
.EnrollmentForm_backButtonArrow__9pIjO {
  fill: #7e818c;
  transition: fill 200ms ease-in-out;
}
.EnrollmentForm_backButton__YaKIM:hover .EnrollmentForm_backButtonArrow__9pIjO {
  fill: #cb9c2d;
  transition: fill 200ms ease-in-out;
}
.EnrollmentForm_backButtonText__Ca6xB {
  color: #7e818c;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
  transition: color 200ms ease-in-out;
}
.EnrollmentForm_backButton__YaKIM:hover .EnrollmentForm_backButtonText__Ca6xB {
  color: #cb9c2d;
  transition: color 200ms ease-in-out;
}
.EnrollmentForm_heading__rn1jv {
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  text-align: left;
}
.EnrollmentForm_attendeeText__4jp6p {
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
}
.EnrollmentForm_displayColumn__HKEen {
  display: flex;
  width: 100%;
  gap: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.EnrollmentForm_displayRow__NsM9K {
  display: flex;
  width: 100%;
  gap: 100px;
  justify-content: flex-start;
  align-items: center;
}
.EnrollmentForm_heading__rn1jv,
.EnrollmentForm_attendeeText__4jp6p,
.EnrollmentForm_userName__rwLv4,
.EnrollmentForm_formTitle__vAXww {
  color: #4d4d4d;
  cursor: default;
  letter-spacing: -0.001em;
  margin: 0px;
  font-family: Inter;
}
.EnrollmentForm_formContainer__Sak7\\+ {
  margin: 24px 0px 0px;
  row-gap: 16px;
}
.EnrollmentForm_form__WbUcW {
  row-gap: 16px;
}
.EnrollmentForm_userName__rwLv4,
.EnrollmentForm_formTitle__vAXww {
  font-weight: 600;
  text-align: left;
  color: #4d4d4d;
}
.EnrollmentForm_userName__rwLv4 {
  font-size: 20px;
  line-height: 22px;
}
.EnrollmentForm_formTitle__vAXww {
  cursor: default;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  margin: 0px;
}
.EnrollmentForm_formDescription__enS-H {
  cursor: default;
}
.EnrollmentForm_formSectionText__CXjl- {
  margin: 0px;
}
.EnrollmentForm_formDescription__enS-H,
.EnrollmentForm_formSectionText__CXjl-,
.EnrollmentForm_opisP__\\+C0Sr {
  color: #5f6d7e;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.001em;
}
.EnrollmentForm_formInputsContainer__-QF0S {
  padding: 24px;
  row-gap: 24px;
}
.EnrollmentForm_formButtonsContainer__orDUP {
  align-items: center;
  border-top: 1px solid #d1d9e2;
  column-gap: 16px;
  display: flex;
  height: 100px;
  justify-content: center;
  width: 100%;
}
.EnrollmentForm_cancelButton__CMY7B {
  background-color: #ebebeb;
  color: #808080;
  text-transform: capitalize;
}
.EnrollmentForm_cancelButton__CMY7B,
.EnrollmentForm_sendButton__WJZtB {
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 52px;
  justify-content: center;
  width: 212px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
  transition: background-color 300ms ease-in-out;
}
.EnrollmentForm_sendButton__WJZtB {
  background-color: #cb9c2d;
  color: #ffffff;
}
.EnrollmentForm_cancelButton__CMY7B:hover {
  background-color: #d1d0d0;
}
.EnrollmentForm_sendButton__WJZtB:hover {
  background-color: #ac8427;
}

.EnrollmentForm_emptyBox__qUO8i {
  height: 100px;
  width: 100%;
}

.EnrollmentForm_disabled__lb6ID {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.EnrollmentForm_acceptanceContainer__d9xyM {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 34px;
  border-radius: 8px;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  color: #4d4d4d;
  justify-content: center;
  pointer-events: none;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}

@media screen and (max-width: 750px) {
  .EnrollmentForm_cancelButton__CMY7B,
  .EnrollmentForm_sendButton__WJZtB {
    width: 30%;
  }
}

@media screen and (max-width: 570px) {
  .EnrollmentForm_cancelButton__CMY7B,
  .EnrollmentForm_sendButton__WJZtB {
    width: 40%;
    height: 48px;
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/documents/components/enrollmentApplications/components/enrollmentForm/EnrollmentForm.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".container {\n  margin: 48px 0px;\n  width: 97.2%;\n}\n.headerRow {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 40px;\n}\n.headerBox,\n.form,\n.formInputsContainer {\n  display: flex;\n  flex-direction: column;\n}\n.backButton {\n  align-items: center;\n  column-gap: 16px;\n  cursor: pointer;\n  display: flex;\n  height: 32px;\n  width: fit-content;\n  margin-bottom: 24px;\n}\n.backButtonArrow {\n  fill: #7e818c;\n  transition: fill 200ms ease-in-out;\n}\n.backButton:hover .backButtonArrow {\n  fill: #cb9c2d;\n  transition: fill 200ms ease-in-out;\n}\n.backButtonText {\n  color: #7e818c;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n  transition: color 200ms ease-in-out;\n}\n.backButton:hover .backButtonText {\n  color: #cb9c2d;\n  transition: color 200ms ease-in-out;\n}\n.heading {\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  text-align: left;\n}\n.attendeeText {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.displayColumn {\n  display: flex;\n  width: 100%;\n  gap: 32px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n.displayRow {\n  display: flex;\n  width: 100%;\n  gap: 100px;\n  justify-content: flex-start;\n  align-items: center;\n}\n.heading,\n.attendeeText,\n.userName,\n.formTitle {\n  color: #4d4d4d;\n  cursor: default;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  font-family: Inter;\n}\n.formContainer {\n  margin: 24px 0px 0px;\n  row-gap: 16px;\n}\n.form {\n  row-gap: 16px;\n}\n.userName,\n.formTitle {\n  font-weight: 600;\n  text-align: left;\n  color: #4d4d4d;\n}\n.userName {\n  font-size: 20px;\n  line-height: 22px;\n}\n.formTitle {\n  cursor: default;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  margin: 0px;\n}\n.formDescription {\n  cursor: default;\n}\n.formSectionText {\n  margin: 0px;\n}\n.formDescription,\n.formSectionText,\n.opisP {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.001em;\n}\n.formInputsContainer {\n  padding: 24px;\n  row-gap: 24px;\n}\n.formButtonsContainer {\n  align-items: center;\n  border-top: 1px solid #d1d9e2;\n  column-gap: 16px;\n  display: flex;\n  height: 100px;\n  justify-content: center;\n  width: 100%;\n}\n.cancelButton {\n  background-color: #ebebeb;\n  color: #808080;\n  text-transform: capitalize;\n}\n.cancelButton,\n.sendButton {\n  align-items: center;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  height: 52px;\n  justify-content: center;\n  width: 212px;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  transition: background-color 300ms ease-in-out;\n}\n.sendButton {\n  background-color: #cb9c2d;\n  color: #ffffff;\n}\n.cancelButton:hover {\n  background-color: #d1d0d0;\n}\n.sendButton:hover {\n  background-color: #ac8427;\n}\n\n.emptyBox {\n  height: 100px;\n  width: 100%;\n}\n\n.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.acceptanceContainer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 34px;\n  border-radius: 8px;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  box-sizing: border-box;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n  color: #4d4d4d;\n  justify-content: center;\n  pointer-events: none;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n\n@media screen and (max-width: 750px) {\n  .cancelButton,\n  .sendButton {\n    width: 30%;\n  }\n}\n\n@media screen and (max-width: 570px) {\n  .cancelButton,\n  .sendButton {\n    width: 40%;\n    height: 48px;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EnrollmentForm_container__yNMMg`,
	"headerRow": `EnrollmentForm_headerRow__uAHFE`,
	"headerBox": `EnrollmentForm_headerBox__-PG-5`,
	"form": `EnrollmentForm_form__WbUcW`,
	"formInputsContainer": `EnrollmentForm_formInputsContainer__-QF0S`,
	"backButton": `EnrollmentForm_backButton__YaKIM`,
	"backButtonArrow": `EnrollmentForm_backButtonArrow__9pIjO`,
	"backButtonText": `EnrollmentForm_backButtonText__Ca6xB`,
	"heading": `EnrollmentForm_heading__rn1jv`,
	"attendeeText": `EnrollmentForm_attendeeText__4jp6p`,
	"displayColumn": `EnrollmentForm_displayColumn__HKEen`,
	"displayRow": `EnrollmentForm_displayRow__NsM9K`,
	"userName": `EnrollmentForm_userName__rwLv4`,
	"formTitle": `EnrollmentForm_formTitle__vAXww`,
	"formContainer": `EnrollmentForm_formContainer__Sak7+`,
	"formDescription": `EnrollmentForm_formDescription__enS-H`,
	"formSectionText": `EnrollmentForm_formSectionText__CXjl-`,
	"opisP": `EnrollmentForm_opisP__+C0Sr`,
	"formButtonsContainer": `EnrollmentForm_formButtonsContainer__orDUP`,
	"cancelButton": `EnrollmentForm_cancelButton__CMY7B`,
	"sendButton": `EnrollmentForm_sendButton__WJZtB`,
	"emptyBox": `EnrollmentForm_emptyBox__qUO8i`,
	"disabled": `EnrollmentForm_disabled__lb6ID`,
	"acceptanceContainer": `EnrollmentForm_acceptanceContainer__d9xyM`
};
export default ___CSS_LOADER_EXPORT___;
